'use client'

import { useEffect, useRef, useState } from 'react'

import { Arrow } from '@/components'

interface ExpandableHTMLProps {
  htmlContent: string
  className?: string
  maxLines?: number
}

/**
 * 展开/收起 文本组件
 */
const ExpandableHTML = ({ htmlContent, className = '', maxLines = 4 }: ExpandableHTMLProps) => {
  const [expanded, setExpanded] = useState(false)
  const [hasOverflow, setHasOverflow] = useState(false)
  const textRef = useRef<HTMLParagraphElement>(null)

  useEffect(() => {
    const checkOverflow = () => {
      const el = textRef.current
      if (!el) return

      const clone = el.cloneNode(true) as HTMLElement
      clone.style.position = 'absolute'
      clone.style.visibility = 'hidden'
      clone.style.pointerEvents = 'none'
      clone.style.webkitLineClamp = 'unset'
      clone.style.display = '-webkit-box'
      clone.style.display = 'block'
      clone.style.webkitBoxOrient = 'vertical'
      clone.style.overflow = 'visible'
      clone.style.maxHeight = 'none'
      clone.classList.remove(`line-clamp-3`)

      document.getElementById('product-short-description')?.appendChild(clone)

      const fullHeight = clone.scrollHeight
      const clampedHeight = el.clientHeight

      if (fullHeight > clampedHeight + 1) {
        setHasOverflow(true)
      }

      document.getElementById('product-short-description')?.removeChild(clone)
    }

    setTimeout(checkOverflow, 50)

    const observer = new MutationObserver(() => {
      setTimeout(checkOverflow, 50)
    })

    if (textRef.current) {
      observer.observe(textRef.current, { childList: true, subtree: true })
    }

    return () => observer.disconnect()
  }, [htmlContent, maxLines])

  return (
    <div id="product-short-description" className={`relative w-full ${className}`}>
      <div
        ref={textRef}
        className={`mt-[14px] break-words font-miSansRegular330 text-base leading-[18px] text-gray-5 xl:mt-4 xl:text-gray-6 ${
          expanded ? 'line-clamp-none max-h-none' : `line-clamp-3 max-h-[54px]`
        } text-ellipsis ${hasOverflow && 'pr-4'} overflow-hidden`}
        dangerouslySetInnerHTML={{ __html: htmlContent || '' }}></div>
      {hasOverflow && (
        <button
          className="absolute bottom-0 right-0 bg-white pl-[6px]"
          onClick={() => setExpanded(!expanded)}>
          <Arrow width={16} height={16} rotate={expanded ? -90 : 90} />
        </button>
      )}
    </div>
  )
}

export default ExpandableHTML
